angular.module('impactx.catalogruleresult').controller('CatalogRuleWithoutProductEncryptionListCtrl',
    CatalogRuleWithoutProductEncryptionListCtrl);

CatalogRuleWithoutProductEncryptionListCtrl.$inject = ['$routeParams'];

function CatalogRuleWithoutProductEncryptionListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogrulewithoutproductencryption.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/rulewithoutproductencryption',
        id: "catalogrulewithoutproductencryptionlist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}